export enum expectedAnswerTypeEffective {
  PD = "PD",
  SD = "SD",
  PR = "PR",
  CR = "CR"
}

export enum expectedAnswerTypeTolerated {
  NoAE = "No AE",
  Grade1AE = "Grade 1 AE",
  Grade2AE = "Grade 2 AE",
  Grade3AE = "Grade 3 AE",
  Grade4AE = "Grade 4 AE"
}
